import React from "react";
// import NavLink from '../SideBar/navBars';
import "./sidebar.css"
// import SideBars from './sidebar';
import SidebarList from './sidebarList';

export default class SideBars extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
    //   <div
    //     className="bg-info"
    //     style={{ position: "fixed", top: "20vh", right: 0 }}
    //   >
    <div className="d-none d-md-flex col-3 px-1 bg-dark overflow-auto" id="sid">
    <ul className="nav flex-column  flex-nowrap  px-3" style={{height: "100vh",paddingTop: "10vh",width:"100%"}}>
          <SidebarList></SidebarList>
    </ul>
    </div>
        // <ul className="bg-dark wrrr" id="sid" >
        //   <li>
        //     <Link
        //       to="/blue"
        //       exact
        //       activeClassName="active"
        //       activeStyle={{
        //           background:"yellow",
        //         fontWeight: "bold",
        //         color: "red"
        //       }}
        //     >
        //       blue1
        //     </Link>
            
        //   </li>
        //   <li>
        //     <Link
        //       to="/red"
              
        //       activeClassName="active"
        //       exact
        //       activeStyle={{
                  
        //         background:"yellow",
        //         fontWeight: "bold",
        //         color: "red"
        //       }}
        //     >
        //       red
        //     </Link>
        //   </li>
        // </ul>
    //   </div>
    );
  }
}
